import log from "loglevel";

const defaultLevel = process.env.NODE_ENV === "production" ? "warn" : "debug";
log.setDefaultLevel(defaultLevel);

export default log;
